<div class="row">
  <div class="col-xxl-12 col-xl-6 box-col-12">
    <div class="card widget-1 widget-with-chart">
      <div class="card-body">
        <span class="help-icon fas fa-info-circle z-index"
          [ngbTooltip]="tooltip.budget.text | translate"
          [placement]="tooltip.budget.placement"
          container="body">
        </span>
        <div>
          <h6 class="mb-1">{{ budget?.total_budget }}{{ currency?.symbol }}</h6>
          <span class="f-light">{{ 'Budget' | translate }}</span>
        </div>
        <div class="order-chart">
          <div id="orderchart">
            <apx-chart
              [series]="totalBudget.series"
              [chart]="totalBudget.chart"
              [colors]="totalBudget.colors"
              [dataLabels]="totalBudget.dataLabels"
              [stroke]="totalBudget.stroke"
              [legend]="totalBudget.legend"
              [grid]="totalBudget.grid"
              [yaxis]="totalBudget.yaxis"
              [tooltip]="totalBudget.tooltip"
              [xaxis]="totalBudget.xaxis"
              [responsive]="totalBudget.responsive"
              [plotOptions]="totalBudget.plotOptions"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xxl-12 col-xl-6 box-col-12">
    <!-- <app-profit></app-profit> -->
    <div class="card widget-1 widget-with-chart">
      <div class="card-body">
        <span class="help-icon fas fa-info-circle z-index"
          [ngbTooltip]="tooltip.remaining.text | translate"
          [placement]="tooltip.remaining.placement"
          container="body">
        </span>
        <div>
          <h6 class="mb-1">{{ budget?.remaining_budget }}{{ currency?.symbol }}</h6>
          <span class="f-light">{{ 'Balance' | translate }}</span>
        </div>
        <div class="order-chart">
          <div id="orderchart">
            <apx-chart
              [series]="totalBalance.series"
              [chart]="totalBalance.chart"
              [colors]="totalBalance.colors"
              [stroke]="totalBalance.stroke"
              [grid]="totalBalance.grid"
              [xaxis]="totalBalance.xaxis"
              [yaxis]="totalBalance.yaxis"
              [responsive]="totalBalance.responsive"
              [dataLabels]="totalBalance.dataLabels"
              [tooltip]="totalBalance.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
